import React from "react";
import { clsx } from "clsx";

import { PhoenixRelatedItems, TickerPills } from "~components/modules";
import { CarouselNav } from "~components/shared/carousel";
import {
    type MediaConfig,
    type MediaFormat,
    Media,
    DEFAULT_MEDIA_PRIORITY,
} from "~components/shared/media/";
import { StoryBlock } from "~components/shared/story-block/StoryBlock";
import { VariantBaseWithHeader } from "~components/shared/variant-base/VariantBase";
import {
    type VariationComponent,
    ZoneColumnCombo,
    isCuratedStory,
    getIsOpinionPageTheme,
} from "~types/types";
import { integrityError } from "~utils/moduleIntegrity";

import integrityCheck from "./LineupContentCarouselBasic.integrity";
import { PREVIEW_NOTES } from "./previewNotes";
import styles from "./LineupContentCarouselBasic.module.css";

const SUPPORTED_REGIONS: ZoneColumnCombo[] = [
    ZoneColumnCombo.leftContentWell,
    ZoneColumnCombo.gridRightRail,
];
export const MEDIA_PRIORITY: MediaFormat[] = DEFAULT_MEDIA_PRIORITY;
const MEDIA_CONFIG: MediaConfig = {
    aspectRatio: 3 / 2,
    className: styles.media,
    desktopMaxWidth: 353,
    mobileMaxWidth: 715,
};

export default function LineupContentCarouselBasic(props: VariationComponent) {
    const { items = [], renderingLocation, theme } = props;

    const integrity = integrityCheck(props);

    if (integrity.length) return integrityError(integrity);

    const isRightRail = renderingLocation === ZoneColumnCombo.gridRightRail;

    return (
        <VariantBaseWithHeader
            source={props}
            className={styles.LineupContentCarousel}
            supportedRegions={SUPPORTED_REGIONS}
            previewNotes={PREVIEW_NOTES}
        >
            <CarouselNav animatedTransition trackingName="contentCarousel">
                {items.map((story, index) => {
                    return (
                        <div
                            className={clsx([
                                styles[renderingLocation],
                                styles.container,
                            ])}
                            key={index}
                        >
                            <Media
                                source={story}
                                priority={MEDIA_PRIORITY}
                                config={MEDIA_CONFIG}
                            />
                            <div>
                                <StoryBlock
                                    storyIndex={1}
                                    story={story}
                                    withDek
                                    isBylineEligible
                                    isSecondaryStory={isRightRail}
                                    withOptionalEyebrow={
                                        !getIsOpinionPageTheme(theme)
                                    }
                                />
                                <TickerPills
                                    storyIndex={1}
                                    tickerIds={story.terminalTickers}
                                />
                                {!isRightRail && isCuratedStory(story) ? (
                                    <PhoenixRelatedItems
                                        storyIndex={1}
                                        relatedItems={
                                            story.relatedStories || []
                                        }
                                        relatedTitle={story.relatedTitle}
                                    />
                                ) : null}
                            </div>
                        </div>
                    );
                })}
            </CarouselNav>
        </VariantBaseWithHeader>
    );
}
